import getPageVisibilityUpToTTAI from './get-page-visibility-up-to-ttai';
export default function getTTAI(interaction) {
  var start = interaction.start,
    end = interaction.end;
  var pageVisibilityUpToTTAI = getPageVisibilityUpToTTAI(interaction);
  return !interaction.abortReason && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
}